export default __webpack_public_path__ + "static/media/about4.0330ca48.png";